import { isNil } from "@eroad/helpers/isNil";
import type { MaybeNull } from "@eroad/types";

import { useStyles } from "./PageTitle.styles";
import type { PageTitleProps } from "./types";

const PageTitleActions = ({ actions }: Pick<PageTitleProps, "actions">): MaybeNull<JSX.Element> => {
  const classes = useStyles();

  if (isNil(actions)) {
    return null;
  }

  return (
    <div className={classes.actions} data-testid="PageTitle-actionButtons">
      {Array.isArray(actions) ? actions.map((action) => action) : actions}
    </div>
  );
};

export { PageTitleActions };
